import HeaderMiddle from "./HeaderMiddle";
import HeaderLeft from "./HeaderLeft";
import HeaderRight from "./HeaderRight";
import { HeaderWrapper } from "./Styles";
import useScreenType from "react-screentype-hook";

const Header = ({ toggleSidebar }) => {
  const { isMobile } = useScreenType();

  if (isMobile) {
    return (
      <HeaderWrapper className="header-mobile-stack">
        <div className="header-mobile-top">
          <HeaderLeft />
          <div className="header-mobile-actions">
            <HeaderRight toggleSidebar={toggleSidebar} />
          </div>
        </div>
        <div className="header-mobile-search">
          <HeaderMiddle alwaysExpandedSearch />
        </div>
      </HeaderWrapper>
    );
  }

  return (
    <HeaderWrapper>
      <HeaderLeft />
      <HeaderMiddle />
      <div className="column second-column">
        <HeaderRight toggleSidebar={toggleSidebar} />
      </div>
    </HeaderWrapper>
  );
};

export default Header;
